<template>
    <div class="d-flex align-items-center">
        <tool-icon v-ripple v-if="dropdown(file)" :name="collapsed ? 'menu-right' : 'menu-down'"
            class="history-folder-arrow" @click="collapsed = !collapsed" />
        <tool-icon :name="icon(file)" :class="cls(file)" />
        <div v-if="type == 3 && from != undefined">
            {{from}}
            <tool-icon name="arrow_right" />
            {{to}}
        </div>
        <del v-else-if="file_strike">
            {{ file.name }}
        </del>
        <div v-else>
            {{ file.name }}
        </div>
    </div>
    <div v-if="type == 4 && from != undefined" class="comments">
        <del style="color: rgba(var(--v-theme-on-surface), 0.6)">
            {{from}}
        </del>
        <div>
            {{to}}
        </div>
    </div>
    <div v-for="(item, index) in decorators" :key="index" class="align-items-center space-between decorator"
        :class="pesmission_strike ? 'strike' : ''">
        <user-view v-if="item.user != undefined" :user="item.user" :size="18" />
        <user-view v-if="item.group != undefined" :group="item.group" :size="18" />
        <div v-if="item.permission != undefined">{{ item.permission }}</div>
    </div>
    <div v-if="(file.files != undefined) && (!collapsed)" class="items">
        <history-folder v-for="sfile in file.files" :key="sfile.id" :file="sfile" :owner="owner" :type="type"
            :root="false" />
    </div>
</template>

<script>
import ToolIcon from '@topomatic/tap/src/components/ToolIcon.vue';
import UserView from '@topomatic/tap/src/components/UserView.vue';
import AppConsts from '../consts';

export default {
    components: { ToolIcon, UserView },
    name: 'HistoryFolder',
    props: {
        file: Object,
        owner: String,
        type: Number,
        root: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            collapsed: ((this.file.files != undefined) && (this.file.files.length > 20)),
        };
    },
    computed: {
        decorators() {
            const { type } = this;
            if (type == undefined) {
                return undefined;
            }
            const { history } = this.file;
            if (history != undefined) {
                switch (type) {
                case 7:
                { // HISTORY_UPDATE_USER_PERMISSION
                    const items = [];
                    const permissions = {};
                    for (let i = 0; i < history.length; i++) {
                        const item = history[i];
                        if (permissions[item.user] == undefined) {
                            permissions[item.user] = item.permissions;
                            items.push({
                                user: this.$api.get_user(item.user),
                                permission: AppConsts.permission_name(item.permissions),
                            });
                        }
                    }
                    return items;
                }
                case 8:
                { // HISTORY_UPDATE_GROUP_PERMISSION
                    const items = [];
                    const permissions = {};
                    for (let i = 0; i < history.length; i++) {
                        const item = history[i];
                        if (permissions[item.user] == undefined) {
                            permissions[item.user] = item.permissions;
                            items.push({
                                group: this.$api.get_group(this.owner, item.group),
                                permission: AppConsts.permission_name(item.permissions),
                            });
                        }
                    }
                    return items;
                }
                case 9:
                { // HISTORY_DELETE_USER_PERMISSION
                    const items = [];
                    const permissions = {};
                    for (let i = 0; i < history.length; i++) {
                        const item = history[i];
                        if (permissions[item.user] == undefined) {
                            permissions[item.user] = 0;
                            items.push({
                                user: this.$api.get_user(item),
                            });
                        }
                    }
                    return items;
                }
                case 10:
                { // HISTORY_DELETE_GROUP_PERMISSION
                    const items = [];
                    const permissions = {};
                    for (let i = 0; i < history.length; i++) {
                        const item = history[i];
                        if (permissions[item.user] == undefined) {
                            permissions[item.user] = 0;
                            items.push({
                                group: this.$api.get_group(this.owner, item),
                            });
                        }
                    }
                    return items;
                }
                default:
                    break;
                }
            }
            return undefined;
        },
        from() {
            const { history } = this.file;
            if ((history != undefined) && (history.length > 0)) {
                return history[history.length - 1].from;
            }
            return undefined;
        },
        to() {
            const { history } = this.file;
            if ((history != undefined) && (history.length > 0)) {
                return history[0].to;
            }
            return undefined;
        },
        file_strike() {
            if (this.root) {
                return false;
            }
            const { type } = this;
            return (type == 5) || (type == 11);
        },
        pesmission_strike() {
            const { type } = this;
            return (type == 9) || (type == 10);
        },
    },
    methods: {
        icon(file) {
            if (file.type == AppConsts.FOLDER_TYPE) {
                return 'folder';
            } if (file.type == AppConsts.DRIVE_TYPE) {
                return 'database';
            }
            return 'file';
        },
        cls(file) {
            if ((file.type == AppConsts.FOLDER_TYPE) || (file.type == AppConsts.DRIVE_TYPE)) {
                if ((file.files != undefined) && (file.files.length > 0)) {
                    return 'folder';
                }
                return 'empty';
            }
            return 'file';
        },
        dropdown(file) {
            return ((file.type == AppConsts.FOLDER_TYPE) || (file.type == AppConsts.DRIVE_TYPE)) && (file.files != undefined) && (file.files.length > 0);
        },
    },
};
</script>

<style scoped>
.folder {
    color: rgb(var(--v-theme-primary));
    margin-right: 4px;
}

.file {
    margin-left: 24px;
    margin-right: 4px;
}

.empty {
    color: rgb(var(--v-theme-primary));
    margin-left: 24px;
    margin-right: 4px;
}

.items {
    margin-left: 24px;
    margin-right: 4px;
}

.decorator {
    color: rgba(var(--v-theme-on-surface), 0.6) !important;
    margin-left: 48px;
    margin-right: 4px;
}

.comments {
    font-size: 80%;
    font-weight: 400;
    padding-left: 48px;
    white-space: pre-wrap;
}

.history-folder-arrow {
    color: rgba(var(--v-theme-on-surface), 0.4) !important;
    cursor: pointer;
    border-radius: 12px;
}
</style>
